// validate email
export default (value) => !!/^[A-Z0-9._+-]+@[A-Z0-9.-]+\.[A-Z]{2,30}$/i.test(value);
